/* eslint-disable react-hooks/rules-of-hooks */
import { Grid, Switch, Tooltip } from '@mui/material';
import { ColumnDef, createColumnHelper } from '@tanstack/table-core';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import DisplayCell from '../../../../pricing-simulator/components/table-columns/display-cell';
import {
  Header,
  ISimulationResultToggleMetadata,
  TableComponent
} from '../../../../pricing-simulator/types/generic-table.model';
import {
  handleInputLevelToggleChange,
  toggleOutputColumnVisibility
} from '../store/table-slice';

export const columnHelper = createColumnHelper<{
  [key: string]: number | string;
}>();

export default function getOutputTableColumn(
  simTableViewMetadata: Header[],
  toggleMetadata: ISimulationResultToggleMetadata,
  footerRows: any[] = [],
  rowData: any = {},
  componentType: TableComponent = TableComponent.PRICING,
  simTableMetadata?: any,
  isSimResults?: boolean
) {
  if (!toggleMetadata?.metadata?.length) {
    return [];
  }
  return [
    columnHelper.group({
      id: 'static-header',
      header: ({ table }) => {
        const { outputToggle, outputToggleOptions } = useAppSelector(
          (state: { table: any }) => state.table
        );
        const appDispatch = useAppDispatch();
        const toggleSwitch = table.getToggleAllColumnsVisibilityHandler();
        return (
          <Grid container justifyContent='space-between'>
            <Grid item>
              {componentType === TableComponent.COGS
                ? simTableMetadata.output_section_label
                : ''}
            </Grid>
            {componentType !== TableComponent.COGS
              ? toggleMetadata.metadata[0].enabled &&
                outputToggleOptions.length === 2 && (
                  <Grid item>
                    <span
                      className={`${
                        outputToggle === outputToggleOptions[0].name
                          ? 'active'
                          : 'non-active'
                      }`}
                    >
                      {outputToggleOptions[0].alias}
                    </span>
                    <Switch
                      checked={outputToggle === outputToggleOptions[1].name}
                      onChange={(e: any, checked: any) => {
                        if (
                          componentType === TableComponent.MULTIYEARESTIMATE
                        ) {
                          appDispatch(
                            handleInputLevelToggleChange({
                              toggledView: checked
                                ? outputToggleOptions[1].name
                                : outputToggleOptions[0].name
                            })
                          );
                        } else {
                          appDispatch(
                            toggleOutputColumnVisibility({
                              toggledView: checked
                                ? outputToggleOptions[1].name
                                : outputToggleOptions[0].name
                            })
                          );
                        }
                        toggleSwitch(e);
                      }}
                      size='small'
                    />
                    <span
                      className={`${
                        outputToggle === outputToggleOptions[1].name
                          ? 'active'
                          : 'non-active'
                      }`}
                    >
                      {outputToggleOptions[1].alias}
                    </span>
                  </Grid>
                )
              : null}
          </Grid>
        );
      },
      columns: simTableViewMetadata.map<
        ColumnDef<{ [key: string]: number | string }>
      >((columnMetadata, index, self) => ({
        accessorKey: columnMetadata.parent.parent_field,
        enableSorting: true,
        header: (props: any) => (
          <Tooltip title={columnMetadata.parent.alias}>
            <span>{columnMetadata.parent.alias}</span>
          </Tooltip>
        ),
        cell: ({ getValue, row }) => {
          if (TableComponent.MULTIYEARESTIMATE === componentType) {
            const isParent = !row.getParentRow();
            if (isParent) {
              return <span>-</span>;
            }
          }
          return (
            <DisplayCell
              key={columnMetadata.parent.parent_field}
              colorCode={columnMetadata.parent.is_cf_enable}
              value={getValue() as number}
              columnMetadata={columnMetadata}
            />
          );
        },
        meta: {
          className: 'last simulation-results',
          style: {},
          rowData,
          isOutputColumn: true
        },
        footer: (props: any) => {
          const data = footerRows?.map(
            (footerRow) =>
              footerRow?.parent?.data[columnMetadata?.parent?.parent_field]
          );
          return (
            <>
              {data.map((val) => (
                <div
                  key={columnMetadata.parent.parent_field}
                  style={{ height: '30px' }}>
                  <DisplayCell
                    colorCode={columnMetadata.parent.is_cf_enable}
                    columnMetadata={columnMetadata}
                    value={val as number}
                  />
                </div>
              ))}
            </>
          );
        }
      })),
      meta: {
        className: 'last simulation-results',
        isOutputColumn: true
      }
    })
  ];
}
